<template>
    <div class='wrapper'>
        <h2 class='d-md-none' > Search Through Our Entire Catalog</h2>
        <h1 class='d-md-flex d-none' > Search Through Our Entire Catalog </h1>
        <v-text-field
            v-model="search"
            solo
            label="Search for products"
            clearable
            class='search-bar mt-6'
            filled
          ></v-text-field>

        <CollectionList :collections="filteredCollections" class='mb-8' id='scroll'> </CollectionList>
        <product-list :products="filteredProducts"></product-list>
    </div>
</template>

<script>
import ProductList from '../components/ProductList.vue'
import axios from "axios"
import CollectionList from '../components/CollectionList.vue'
export default {
    data () {
        return {
            products: [],
            search: '',
            activeProducts: [],
            activeCollections: [],
            collections: [],
            collection: [],
        }
    },
    async mounted () {
      
         
 
    },
    components: {
        ProductList,
        CollectionList,
    },
    computed: {
        filteredProducts: function() {
            return this.products.filter((product) => {
                return product.name.toLowerCase().match(this.search.toLowerCase())
            })
        },
        filteredCollections: function() {
            return this.collections.filter((product) => {
                return product.collectionName.toLowerCase().match(this.search.toLowerCase())
            })
        },

    },
    async created () {
        this.$store.commit('clearCollections')
        this.$store.commit('clearProducts')
        
        let productSQL = ''

        
        productSQL = await this.getProductSQL('SearchProducts', 'Placeholder')
        productSQL = productSQL.data
        this.buildProductFromSQLData(productSQL)
        // this.products = this.$store.getters.getProducts
     




        productSQL = await this.getProductSQL('Search', 'Placeholder')
        productSQL = productSQL.data
    
        this.activeCollections = productSQL
        this.$store.commit('addCollection', this.activeCollections)
        this.activeCollections.forEach(collection => {
            collection.collectionImage = collection.collectionImage.replaceAll("'", "")
        })

        this.collection = this.$store.getters.getCollections
        this.collections = this.collection[0]
        

        
        
        console.log(this.products)
        
    },

    methods: {
        async getProductSQL(category, productIDS){
                const params = {
                    Category: category,
                    getCollection: false,
                    idString: productIDS,
                }

                return axios.get("https://hyx3msvo51.execute-api.us-east-1.amazonaws.com/GetProductSQL", { params })
                    .then((response) => {
                        console.log('Successfully Connected')
                        return response
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            buildProductFromSQLData(ProductData){
                ProductData.forEach(sqlData => {
                        var product = {
                            id: sqlData.productID,
                            name: sqlData.productName,
                            category: sqlData.productCategory, 
                            productRoom: sqlData.productRoom, 
                            price: parseFloat(sqlData.productPrice),
                            msrp: parseFloat(sqlData.productMSRP),
                            description: sqlData.productDescription,
                            collectionIDS: sqlData.collectionIDS, 
                            mainImage: sqlData.productImage,
                            imageURLS: sqlData.productImages.split(','), 
                            varients: (sqlData.varientLink === 'undefined') ? [] : sqlData.varientLink.split(','),
                            weight: parseFloat(sqlData.productWeight),
                            length: parseFloat(sqlData.productLength), 
                            width: parseFloat(sqlData.productWidth), 
                            height: parseFloat(sqlData.productHeight),
                            cbm: parseFloat(sqlData.productCBM),
                            productSlug: sqlData.productSlug,
                            stock: parseInt(sqlData.productStock), 
                            restockDate: (sqlData.productRestockDate === 'undefined') ? undefined : sqlData.productRestockDate,
                        }

                        //this.$store.commit('addProduct', product)
                        this.products.push(product)
                })
                this.$store.commit('addProducts', this.products)
            }, 


    }
  }

</script>

<style scoped>
    .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .search-bar {
        width: 60vw;
    }

</style>